<template>
	<div class="chat-box chat-box-empty">
		<el-container>
			<!-- 头部区域：与 ChatBox 同高（50px），未选中会话时不提供任何操作入口 -->
			<el-header height="50px">
				<div class="header-left">
					<span>未选择会话</span>
				</div>
			</el-header>
			<!-- 消息区 + 输入区：骨架尺寸与 ChatBox 完全对齐（footer 固定 220px），选中会话切换时无跳变 -->
			<el-main style="padding: 0; overflow: hidden; display: flex; flex-direction: column;">
				<el-container>
					<el-container class="content-box is-vertical">
						<el-main class="im-chat-main">
							<div class="empty-guide">
								<i class="el-icon-chat-line-round empty-guide-icon"></i>
								<p class="empty-guide-title">{{ guideTitle }}</p>
								<p class="empty-guide-desc">{{ guideDesc }}</p>
							</div>
						</el-main>
						<el-footer height="220px" class="im-chat-footer">
							<!-- 工具栏：复刻 ChatBox 的通用图标并整体置灰，不绑定任何交互 -->
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji"></div>
								<div title="发送图片"><i class="el-icon-picture-outline"></i></div>
								<div title="发送文件"><i class="el-icon-wallet"></i></div>
								<div title="发送视频"><i class="el-icon-video-camera"></i></div>
								<div title="发送位置"><i class="el-icon-location-outline"></i></div>
								<div title="发送名片" class="el-icon-postcard"></div>
								<div title="发送语音" class="el-icon-microphone"></div>
								<div title="内容脱敏" class="el-icon-magic-stick"></div>
							</div>
							<div class="send-content-area">
								<!-- 输入框为纯静态展示，文案与 ChatInput 的 placeholder 保持一致 -->
								<div class="empty-input">请输入消息（按Ctrl+Enter键换行）</div>
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion" disabled>发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
				</el-container>
			</el-main>
		</el-container>
	</div>
</template>

<script>
// 未选中会话时的聊天面板占位：仅展示骨架，不挂载任何消息/发送逻辑
export default {
	name: "EmptyChatBox",
	computed: {
		// 列表是否还有可见会话，决定引导文案（空列表时引导去发起会话）
		hasVisibleChat() {
			// 首屏同步窗口内 state.chats 被置换为空、真实列表暂存在 cacheChats，
			// 必须走 findChats() 取数，否则会误判为「暂无会话」导致文案闪烁
			const chats = this.chatStore.findChats() || [];
			return chats.some(c => c && !c.delete);
		},
		guideTitle() {
			return this.hasVisibleChat ? "选择一个会话开始聊天" : "暂无会话";
		},
		guideDesc() {
			return this.hasVisibleChat
				? "从左侧会话列表点击任意会话，即可查看消息并回复"
				: "可点击会话列表右上角的「+」发起新会话";
		}
	}
};
</script>

<style lang="scss" scoped>
.chat-box-empty {
	position: relative;
	width: 100%;
	background: #fff;

	.el-header {
		display: flex;
		justify-content: space-between;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);

		.header-left {
			display: flex;
			align-items: center;
			overflow: hidden;
			min-width: 0;
			color: var(--im-text-color-lighter);
		}
	}

	.content-box {
		position: relative;

		.im-chat-main {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			overflow: hidden;
			background-color: #f4f5f6;
		}

		.empty-guide {
			text-align: center;
			user-select: none;

			.empty-guide-icon {
				font-size: 56px;
				color: #dcdfe6;
			}

			.empty-guide-title {
				margin: 16px 0 6px;
				font-size: var(--im-font-size-larger);
				color: var(--im-text-color-light);
			}

			.empty-guide-desc {
				margin: 0;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-lighter);
			}
		}

		.im-chat-footer {
			display: flex;
			flex-direction: column;
			padding: 0;

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 36px;
				text-align: left;
				box-sizing: border-box;
				border-top: var(--im-border);
				padding: 4px 2px 2px 8px;

				// 置灰禁用态：不响应 hover、不显示可点击光标
				>div {
					font-size: 22px;
					line-height: 30px;
					width: 30px;
					height: 30px;
					text-align: center;
					border-radius: 2px;
					margin-right: 8px;
					color: #c0c4cc;
					cursor: default;
				}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: #fff;

				.empty-input {
					height: 100%;
					padding: 5px;
					line-height: 26px;
					font-size: var(--im-font-size);
					text-align: left;
					color: #c0c4cc;
					user-select: none;
					cursor: default;
				}

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}
		}
	}
}
</style>
